import {
  searchRoomHistory as apiSearchRoomHistory,
  fetchRoomHistoryById as apiFectRoomHistoryById,
  addRoomHistoryRsv as apiAddRoomHistoryRsv,
} from "../../api/roomHistory";

// Action Types
export const SEARCH_ROOM_HISTORY_REQUEST = "SEARCH_ROOM_HISTORY_REQUEST";
export const SEARCH_ROOM_HISTORY_SUCCESS = "SEARCH_ROOM_HISTORY_SUCCESS";
export const SEARCH_ROOM_HISTORY_FAILURE = "SEARCH_ROOM_HISTORY_FAILURE";

// Action Types
export const FETCH_ROOM_HISTORY_BY_ID_REQUEST =
  "FETCH_ROOM_HISTORY_BY_ID_REQUEST";
export const FETCH_ROOM_HISTORY_BY_ID_SUCCESS =
  "FETCH_ROOM_HISTORY_BY_ID_SUCCESS";
export const FETCH_ROOM_HISTORY_BY_ID_FAILURE =
  "FETCH_ROOM_HISTORY_BY_ID_FAILURE";

// Action Types
export const ADD_ROOM_HISTORY_RSV_REQUEST = "ADD_ROOM_HISTORY_RSV_REQUEST";
export const ADD_ROOM_HISTORY_RSV_SUCCESS = "ADD_ROOM_HISTORY_RSV_SUCCESS";
export const ADD_ROOM_HISTORY_RSV_FAILURE = "ADD_ROOM_HISTORY_RSV_FAILURE";

// Action Creators
export const searchRoomHistoryRequest = () => ({
  type: SEARCH_ROOM_HISTORY_REQUEST,
});

export const searchRoomHistorySuccess = (history) => ({
  type: SEARCH_ROOM_HISTORY_SUCCESS,
  payload: history,
});

export const searchRoomHistoryFailure = (error) => ({
  type: SEARCH_ROOM_HISTORY_FAILURE,
  payload: error,
});

// Action Creators
export const fetchRoomHistoryByIdRequest = (id) => ({
  type: FETCH_ROOM_HISTORY_BY_ID_REQUEST,
  requestId: id,
});

export const fetchRoomHistoryByIdSuccess = (history, id) => ({
  type: FETCH_ROOM_HISTORY_BY_ID_SUCCESS,
  requestId: id,
  payload: history,
});

export const fetchRoomHistoryByIdFailure = (error, id) => ({
  type: FETCH_ROOM_HISTORY_BY_ID_FAILURE,
  requestId: id,
  payload: error,
});

// Action Creators
export const addRoomHistoryRsvRequest = () => ({
  type: ADD_ROOM_HISTORY_RSV_REQUEST,
});

export const addRoomHistoryRsvSuccess = (reservation) => ({
  type: ADD_ROOM_HISTORY_RSV_SUCCESS,
  payload: reservation,
});

export const addRoomHistoryRsvFailure = (error) => ({
  type: ADD_ROOM_HISTORY_RSV_FAILURE,
  payload: error,
});

export const searchRoomHistory = (startDate, endDate) => async (dispatch) => {
  const START_DATE = "0000-01-01";
  const END_DATE = "9999-12-31";
  dispatch(searchRoomHistoryRequest());
  try {
    const history = await apiSearchRoomHistory(START_DATE, END_DATE);
    dispatch(searchRoomHistorySuccess(history.result));
  } catch (error) {
    console.error("Error fetching room history:", error); // Debugging
    dispatch(searchRoomHistoryFailure(error.message));
  }
};

// export const searchRoomHistory = (startDate, endDate) => async (dispatch) => {
//   dispatch(searchRoomHistoryRequest());
//   try {
//     const history = await apiSearchRoomHistory(startDate, endDate);
//     dispatch(searchRoomHistorySuccess(history.result));
//   } catch (error) {
//     console.error("Error fetching room history:", error); // Debugging
//     dispatch(searchRoomHistoryFailure(error.message));
//   }
// };

export const fetchRoomHistoryById = (id) => async (dispatch) => {
  dispatch(fetchRoomHistoryByIdRequest(id));
  try {
    const history = await apiFectRoomHistoryById(id);
    dispatch(fetchRoomHistoryByIdSuccess(history.data, id));
    return history.data;
  } catch (error) {
    console.error("Error fetching room history:", error); // Debugging
    dispatch(fetchRoomHistoryByIdFailure(error.message, id));
    throw error;
  }
};

export const addRoomHistoryRsv = (reservationData) => async (dispatch) => {
  dispatch(addRoomHistoryRsvRequest());
  try {
    const reservation = await apiAddRoomHistoryRsv(reservationData);
    dispatch(addRoomHistoryRsvSuccess(reservation.result));
  } catch (error) {
    console.error("Error adding room history reservation:", error); // Debugging
    dispatch(addRoomHistoryRsvFailure(error.message));
  }
};
